module.exports = __webpack_public_path__ + "img/news_banner.946c7397.png";